<template>
  <div>
    <v-subheader
      :class="[
        $vuetify.theme.dark ? 'black grey--text' : 'grey lighten-3 secondary--text',
        'guest-list-header text-h6 font-weight-medium pa-0 d-flex align-stretch'
      ]"
    >
      <span class="guest-list-header__title d-flex align-center pl-3">{{ title }}</span>
      <span
        v-if="showCounts"
        class="guest-list-header__counts d-flex ml-auto flex-shrink-0 h-100"
      >
        <span class="guest-list-header__cell guest-list-header__inc d-flex align-center justify-center px-1 text-caption font-weight-bold">{{ incoming }}</span>
        <span class="guest-list-header__cell guest-list-header__std d-flex align-center justify-center px-1 text-caption">{{ seated }}</span>
      </span>
    </v-subheader>
    <v-divider />
  </div>
</template>

<script lang='ts' setup>
import { computed } from 'vue';

const props = defineProps({
  title: { type: String, required: true },
  incoming: { type: Number, default: undefined },
  seated: { type: Number, default: undefined },
});

const showCounts = computed(() => {
  if (props.incoming === undefined || props.seated === undefined) return false;
  return props.incoming > 0 || props.seated > 0;
});

</script>

<style scoped lang="scss">

  .guest-list-header {
    height: 24px !important;
    font-size: 1.15rem !important;
  }

  .guest-list-header__title {
    min-width: 0;
  }

  .guest-list-header__counts {
    --glh-border: #{$grey-15-color};

    .theme--dark & {
      --glh-border: #{$grey-75-color};
    }

    border-left: 1px solid var(--glh-border);
    border-right: 1px solid var(--glh-border);
  }

  .guest-list-header__cell {
    box-sizing: border-box;
    min-width: 20px;
    line-height: 1;

    & + & {
      border-left: 1px solid var(--glh-border);
    }
  }

  .guest-list-header__inc {
    color: $grey-66-color;

    .theme--dark & {
      color: $grey-22-color;
    }
  }

  .guest-list-header__std {
    font-weight: 600;
    color: $grey-50-color;

    .theme--dark & {
      color: $grey-60-color;
    }
  }

</style>
